
import axios from '../index'

export function searchLocations(params) {
  return axios.get(`/ajax/clients/search_api_locations?query=${params['query']}`, params)
}